import { FormGroup, FormHelpText, FormTextarea, FormPopoverTrigger, Popover } from '@spotify-internal/encore-web';
import PropTypes from 'prop-types';

import withTranslation from 'lib/shared/i18n/withTranslation';
import BaseField from 'components/Fields/BaseField/BaseField';
import { isValidSpotifyUriList } from 'components/ContentReporting/validation-utils';
import styles from 'components/Fields/TextareaField/TextareaField.module.scss';

class MultipleUrisField extends BaseField {
  static propTypes = {
    t: PropTypes.func.isRequired,
    field: PropTypes.object.isRequired,
    value: PropTypes.string,
    labelOverride: PropTypes.string,
    acceptedUriTypes: PropTypes.arrayOf(PropTypes.string),
    maximumNumberOfURI: PropTypes.number,
    usePopOver: PropTypes.bool,
  };

  getLabel() {
    const { t, field, labelOverride, tPrefix } = this.props;

    if (labelOverride) {
      return t(tPrefix + labelOverride);
    }
    return t(`${tPrefix}${field.name}_label`);
  }

  isValid(value) {
    return (
      isValidSpotifyUriList(value, this.props.acceptedUriTypes, this.props.maximumNumberOfURI) && super.isValid(value)
    );
  }

  render() {
    const { field, t, value, usePopOver } = this.props;
    const { popOverOpen } = this.state;
    const helpText = field.help_text && t(`${field.name}_help_text`);
    const indicator = field.required ? 'required' : null;

    return (
      <FormGroup
        key={field.name}
        label={this.getLabel()}
        labelFor={field.name}
        indicator={indicator}
        popover={
          usePopOver && (
            <FormPopoverTrigger
              placement={FormPopoverTrigger.left}
              overlay={
                popOverOpen && (
                  <Popover arrow={Popover.left}>{t('infringement_claim_form:content_uris_tooltip')}</Popover>
                )
              }
              onShow={() => this.setPopover(true)}
              onHide={() => this.setPopover(false)}
              aria-label="Help"
            />
          )
        }
      >
        <FormTextarea
          className={styles.textarea}
          id={field.name}
          aria-describedby={this.getAriaDescribedBy()}
          aria-required={field.required}
          aria-invalid={this.showError()}
          onChange={this.fieldChange}
          value={value}
          error={this.getError()}
          maxLength={field.maxlength}
        />
        {(helpText || field.maxlength) && (
          <div className={styles.caption}>
            {helpText && <FormHelpText>{helpText}</FormHelpText>}
            {field.maxlength && (
              <FormHelpText className={styles.charCounter}>{field.maxlength - value.length}</FormHelpText>
            )}
          </div>
        )}
        {this.getError()}
      </FormGroup>
    );
  }
}

export default withTranslation()(MultipleUrisField);
